import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'
import { guestModifiedMiddleware } from './middleware/guestModifiedMiddleware'
import { rootReducer } from './rootReducer'

// Sagas
import { watchAuthSaga } from './auth/authSaga'
import { watchWorkspaceSaga } from './workspace/workspaceSaga'
import { watchProjectsSaga } from './projects/projectsSaga'
import { watchListsSaga } from './lists/listsSaga'
import { watchTasksSaga } from './tasks/tasksSaga'

import { watchCommentsSaga } from './comments/commentsSaga'
import { watchNotificationsSaga } from './notifications/notificationsSaga'
import { watchInitialStateSaga } from './initialState/initialStateSaga'
import { watchApiKeysSaga } from './apiKeys/apiKeysSaga'
import { watchActivitySaga } from './activity/activitySaga'
import { watchAgentStatusSaga } from './agentStatus/agentStatusSaga'
import { watchAdminSaga } from './admin/adminSaga'

const sagaMiddleware = createSagaMiddleware()

function* rootSaga() {
    yield all([
        watchAuthSaga(),
        watchWorkspaceSaga(),
        watchProjectsSaga(),
        watchListsSaga(),
        watchTasksSaga(),

        watchCommentsSaga(),
        watchNotificationsSaga(),
        watchInitialStateSaga(),
        watchApiKeysSaga(),
        watchActivitySaga(),
        watchAgentStatusSaga(),
        watchAdminSaga(),
    ])
}

export const store = configureStore({
    reducer: rootReducer,

    middleware: (getDefaultMiddleware: any) =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
        .concat(sagaMiddleware)
        .concat(guestModifiedMiddleware),
} as any)

sagaMiddleware.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
